var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row-card",
      on: { mouseenter: _vm.mouseIn, mouseleave: _vm.mouseOut },
    },
    [
      _c(
        "div",
        {
          staticClass: "preview",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.play.apply(null, arguments)
            },
          },
        },
        [
          _c("div", {
            staticClass: "pic cvr",
            style: { backgroundImage: "url(" + _vm.posterSrc + ")" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tp" }, [
            _vm.moneyTag
              ? _c(
                  "span",
                  {
                    staticClass: "m-tag ft-bld",
                    style: { background: _vm.Global.mockupConfig.colors.icons },
                  },
                  [_vm._v(_vm._s(_vm.moneyTag))]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btm col" }, [
            _c("span", { staticClass: "name-title ft-xbld" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _vm.progressPerc
              ? _c("div", { staticClass: "progress" }, [
                  _c("span", {
                    staticClass: "inner",
                    style: { width: _vm.progressPerc + "%" },
                  }),
                ])
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "extended", class: { active: _vm.isExtended } },
        [
          _c(
            "div",
            {
              staticClass: "top preview",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.play.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                staticClass: "pic cvr",
                style: { backgroundImage: "url(" + _vm.posterSrc + ")" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "bottom" }, [
            _c("div", { staticClass: "bg" }),
            _vm._v(" "),
            _c("div", { staticClass: "actions" }, [
              _vm.moneyTag != "Free"
                ? _c(
                    "div",
                    {
                      staticClass: "btn main ply sub",
                      style: {
                        background: _vm.Global.mockupConfig.colors.icons,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openSubOverlay.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "ico" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "24",
                              viewBox: "0 0 21 24",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z",
                                fill: "black",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "txt" }, [_vm._v("Subscribe")]),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "btn main ply",
                      style: {
                        background: _vm.Global.mockupConfig.colors.icons,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.play.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "ico" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "21",
                              height: "24",
                              viewBox: "0 0 21 24",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z",
                                fill: "black",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.progressPerc
                        ? _c("span", { staticClass: "txt" }, [_vm._v("Resume")])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.progressPerc && _vm.moneyTag == "Free"
                        ? _c("span", { staticClass: "txt" }, [_vm._v("Play")])
                        : _vm._e(),
                    ]
                  ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sqr i",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.show.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "ico" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "26",
                          height: "26",
                          viewBox: "0 0 26 26",
                          fill: "none",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: { cx: "13", cy: "13", r: "13", fill: "white" },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: { cx: "13", cy: "7", r: "2", fill: "#696969" },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M13 12V19",
                            stroke: "#696969",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sqr add" }, [
                _c("span", { staticClass: "ico" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "26",
                        height: "26",
                        viewBox: "0 0 26 26",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M13 2V24",
                          stroke: "white",
                          "stroke-width": "4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M2 13H24",
                          stroke: "white",
                          "stroke-width": "4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sqr vol" }, [
                _c("span", { staticClass: "ico" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "29",
                        height: "23",
                        viewBox: "0 0 29 23",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M6.5 6.91872H3.33333C2.59733 6.91872 2 7.51605 2 8.25205V14.5854C2 15.3214 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4134C12.672 21.1481 14 20.5321 14 19.3961V3.44138C14 2.30538 12.6707 1.68938 11.8053 2.42405L6.5 6.91872Z",
                          fill: "white",
                          stroke: "white",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M19.3828 16.7226C20.9321 15.76 22.0001 13.7573 22.0001 11.4253C22.0001 9.09329 20.9321 7.08929 19.3828 6.11462",
                          stroke: "white",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M23.3407 20.8387C25.7513 18.7653 27.334 15.3253 27.334 11.4227C27.334 7.51467 25.7487 4.072 23.334 2",
                          stroke: "white",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "sum" }, [_vm._v(_vm._s(_vm.description))]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }